module.exports = __webpack_public_path__ + "static/media/CNX-CNX-40-iQ.f03dd28c.png";